import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { canAccessPage } from '../utils/pagePermissions';

const PrivateRoute = ({ children, requiredRole = null, adminRequired = false, requiredPage = null }) => {
  const { isAuthenticated, user, loading } = useContext(AuthContext);

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const ADMIN_ROLES = ['ADMIN', 'SUPERADMIN', 'IT', 'HR', 'FACILITY', 'COUNTRY_ADMIN'];
  if (adminRequired && !ADMIN_ROLES.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requiredRole && user?.role !== requiredRole && !ADMIN_ROLES.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  // Page-level permission check (bypass for SUPERADMIN or when allowedPages is empty)
  if (requiredPage && !canAccessPage(user, requiredPage)) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default PrivateRoute;
